import { render, staticRenderFns } from "./BlogArticleCard.vue?vue&type=template&id=24c135b8"
import script from "./BlogArticleCard.vue?vue&type=script&lang=js"
export * from "./BlogArticleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports